import { Component } from '@angular/core';
import { TranslatePipe } from '../../../../../shared/pipes/translate-pipe';

@Component({
  selector: 'app-auth-layout-signup',
  imports: [TranslatePipe],
  templateUrl: './auth-layout-signup.component.html',
  styleUrl: './auth-layout-signup.component.scss',
})
export class AuthLayoutSignupComponent {}
